import React from "react";
import { Typography, Input, Select, Col } from "antd";
import { TitleContainer } from "./elements";
import { productTypes } from "../../../utils/constants";

const { Option } = Select;

const { Text } = Typography;

interface TableTitleProps {
  setNameFilter: (value: string) => void;
  setTypeFilter: (value: string) => void;
}

const TableTitle: React.FC<TableTitleProps> = ({
  setNameFilter,
  setTypeFilter,
}) => {
  return (
    <TitleContainer>
      <Col
        span={24}
        style={{
          display: "flex",
          justifyContent: "left",
          alignItems: "center",
        }}
      >
        <div>
          <Text style={{ fontWeight: "700",
            fontSize: 18 }}>
            Buscar producto:{" "}
          </Text>
          <br />
          <Input
            style={{ width: 250,
              marginRight: 15 }}
            placeholder="Buscar por nombre"
            allowClear
            onChange={(e) => setNameFilter(e.target.value)}
          />
        </div>
        {/* <div>
          <Text>Categoria: </Text>
          <Select
            placeholder="Buscar por Categoria"
            allowClear
            style={{ width: 250,
              marginLeft: 5,
              marginRight: 15 }}
            onChange={(value) => setTypeFilter(value)}
          >
            <Option value={"main"}>Principal</Option>
          </Select>
        </div> */}
        <div>
          <Text style={{ fontWeight: "700",
            fontSize: 18 }}>
            Filtrar por Tipo:{" "}
          </Text>
          <br />
          <Select
            placeholder="Buscar por Tipo"
            allowClear
            style={{ width: 250,
              marginRight: 15 }}
            onChange={(value) => setTypeFilter(value)}
          >
            {Object.entries(productTypes)?.map(([key, value]) => (
              <Option value={key} key={key}>
                {value}
              </Option>
            ))}
          </Select>
        </div>
      </Col>
    </TitleContainer>
  );
};

export default TableTitle;
